import axios from 'axios'
import { ALTERAR_REPASSE_VENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function alterarComprovanteRepasseVenda(repasse) {
  const url = `${URL}/repasse-venda/alterar-comprovante-transferencia`;
  return dispatch => axios.post(url, repasse, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type:ALTERAR_REPASSE_VENDA ,
        payload: response
      })
  );
}